export default function getField(item, key) {
  if (!item) return undefined;
  const found = Object.keys(item).find(k => k.toLowerCase() === key.toLowerCase());
  return found ? item[found] : undefined;
}
